import { Link, useLocation } from "react-router";

interface MenuItemProps {
  path: string;
  label: string;
}

export default function MenuItem({ path, label }: MenuItemProps) {
  const location = useLocation();
  const isInternalLink = path && path.startsWith("/");
  const isActivePage = location.pathname.includes(path);

  return (
    <li
      className={`text rounded hover:bg-slate-50 ${isActivePage ? "font-medium" : null}`}
    >
      {isInternalLink ? (
        <Link
          className="block px-4 py-2.5 select-none lg:inline-block"
          to={path}
        >
          <span
            className={`relative font-medium ${isActivePage ? "text-blue-700 after:absolute after:bottom-[-20px] after:left-0 after:h-[3px] after:w-full after:content-[''] lg:after:bg-blue-500" : "text-gray-700"}`}
          >
            {label}
          </span>
        </Link>
      ) : (
        <a
          className="block px-4 py-2.5 select-none lg:inline-block"
          href={path}
        >
          <span
            className={`relative font-medium ${isActivePage ? "text-blue-700 after:absolute after:bottom-[-20px] after:left-0 after:h-[3px] after:w-full after:content-[''] lg:after:bg-blue-500" : "text-gray-700"}`}
          >
            {label}
          </span>
        </a>
      )}
    </li>
  );
}
